module.exports = __webpack_public_path__ + "static/media/bedroom_workout_f.c53a208a.webp";